export enum ToolpanelType {
  settings,
  column,
  filter,
}
